// Run a callback when the DOM is ready.
//
// Uses jQuery's ready mechanism when available to ensure consistent ordering
// with other jQuery ready callbacks (e.g. Slzr.Meta population in
// onready.js). jQuery 3.x defers .ready() callbacks as microtasks via
// .then(), so mixing native DOMContentLoaded with jQuery ready can cause race
// conditions where native listeners fire before jQuery ready callbacks.
export const onDomReady = (cb = () => {}) => {
  if (typeof jQuery !== "undefined") {
    jQuery(cb);
  } else if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cb);
  } else {
    cb();
  }
};

// Run a callback when a specific page, identified by <meta name="localist-page">, is DOM ready.
//
// If the page is already DOM ready, run the callback immediately.
export const activateOnPage = (page, cb = () => {}) => {
  onDomReady(() => {
    if (Slzr?.Meta?.page === page) {
      cb();
    }
  });
};

// Split class names into an array of non-empty tokens
export const splitClassNames = (str) =>
  (str ?? "").trim().split(/\s+/).filter(Boolean);

